import { motion } from 'framer-motion'
import Container from '@comp/ui/container'
import Section from '@comp/ui/section'
import Eyebrow from '@comp/ui/eyebrow'
import Heading from '@comp/ui/heading'
import Text from '@comp/ui/text'
import Button from '@comp/ui/button'

const EASE = [0.22, 1, 0.36, 1] as const

export default function MediaInquiry() {
  return (
    <Section tone="inverse" density="default" id="media">
      <Container size="xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, ease: EASE }}
          className="grid gap-12 lg:grid-cols-[1.2fr_1fr] lg:items-end lg:gap-20"
        >
          <div>
            <Eyebrow tone="inverse">Media inquiries</Eyebrow>
            <Heading as="h2" size="display-lg" tone="inverse" className="mt-5">
              Working on a story?
              <br />
              We will help.
            </Heading>
            <Text size="xl" className="mt-6 !text-brand-100">
              Reach out for interviews, executive availability, customer
              references, or product briefings. We respond within one business
              day.
            </Text>
            <div className="mt-10 flex flex-wrap items-center gap-3">
              <Button
                href="mailto:press@monofor.com"
                variant="inverse"
                size="lg"
              >
                Email press@monofor.com
              </Button>
              <Button href="/contact" variant="outline" size="lg">
                Open the contact form
              </Button>
            </div>
          </div>

          <ul className="space-y-4 rounded-3xl bg-white/5 p-8 backdrop-blur lg:p-10">
            <ContactRow
              label="Press &amp; media"
              value="press@monofor.com"
              href="mailto:press@monofor.com"
            />
            <ContactRow
              label="Analyst relations"
              value="analyst@monofor.com"
              href="mailto:analyst@monofor.com"
            />
            <ContactRow
              label="Sales"
              value="sales@monofor.com"
              href="mailto:sales@monofor.com"
            />
            <ContactRow
              label="Partnerships"
              value="partners@monofor.com"
              href="mailto:partners@monofor.com"
            />
          </ul>
        </motion.div>
      </Container>
    </Section>
  )
}

function ContactRow({
  label,
  value,
  href,
}: {
  label: string
  value: string
  href: string
}) {
  return (
    <li className="flex items-center justify-between gap-6 border-b border-white/10 pb-4 last:border-b-0 last:pb-0">
      <span className="text-eyebrow font-semibold uppercase text-brand-200/80">
        {label}
      </span>
      <a
        href={href}
        className="text-body-md font-medium text-white transition hover:text-brand-100"
      >
        {value}
      </a>
    </li>
  )
}
